import { useNavigate } from "react-router-dom";
import { RoutesLink } from "../../../../ApiHelper/RoutesLink";
import PlusIcon from "../../../../components/Icons/PlusIcon";
import { useEffect, useState } from "react";
import EditIcon from "../../../../components/Icons/EditIcon";
import DeleteIcon from "../../../../components/Icons/DeleteIcon";
import { callApi } from "../../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import moment from "moment";
import MainHeading from "../../../../components/comman/MainHeading";
import FilterComponent from "../../../../components/comman/FilterComponent";
import CommonTable from "../../../../components/comman/CommonTable";
import ConfirmModal from "../../../../components/comman/ConfirmModal";
import { MainFilterHandler } from "../../../../components/comman/MainFilterHandler";

export default function ShiftAndTimeConfig() {
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [selectedId, setSelectedId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    shiftData: [],
    filterData: "",
  });

  useEffect(() => {
    GetShiftList(pageStates?.currentPage);
  }, [pageStates?.pageSize, pageStates.currentPage]);

  const GetShiftList = (pageNumber, filteredData) => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_shift + "?" + MainFilterHandler(pageStates);
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      shiftData: [],
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.shift?.map((item) => ({
          ...item,
          startTime1: item?.startTime ? moment(item?.startTime, "HH:mm:ss").format("hh:mm A") : "--",
          endTime1: item?.endTime ? moment(item?.endTime, "HH:mm:ss").format("hh:mm A") : "--",
          checkInBufferTime1: item?.checkInBufferTime ? moment(item?.checkInBufferTime, "HH:mm:ss").format("hh:mm A") : "--",
          checkOutBufferTime1: item?.checkOutBufferTime ? moment(item?.checkOutBufferTime, "HH:mm:ss").format("hh:mm A") : "--",
          firstHalf1: item?.firstHalf != null ? moment(item?.firstHalf, "HH:mm:ss").format("hh:mm A") : "--",
          secondHalf1: item?.secondHalf != null ? moment(item?.secondHalf, "HH:mm:ss").format("hh:mm A") : "--",
        }))
        setPageStates((prevStates) => ({
          ...prevStates,
          shiftData: newData,
          count: response?.data?.pageInfo?.total,
          totalPages: response?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
      // GetShiftList(PageNo, pageStates?.filterData);
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1
    }));
  };

  const ActionHandler = (data) => {
    setSelectedId(data?.id)
    toggle();
  }

  const HandleUpdate = (data) => {
    navigate(RoutesLink?.add_Shift, { state: { data: data } })
  };

  const HandleDelete = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.delete_shift + `?shiftId=${selectedId}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        toggle();
        GetShiftList(pageStates?.currentPage);
      } else {
        toast.error(response?.message);
        toggle();
      }
    });
  };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "type", label: "Work Type" },
    { value: "shiftName", label: "Shift Name" },
    { value: "startTime1", label: "Start Time" },
    { value: "endTime1", label: "End Time" },
    { value: "checkInBufferTime1", label: "Check-In-Buffer Time" },
    { value: "checkOutBufferTime1", label: "Check-Out-Buffer Time" },
  ];

  const ActionData = [
    {
      label: "Edit",
      className: "btn btn-link",
      icon: <EditIcon />,
      title: "edit",
      clickHandler: HandleUpdate,
    },
    {
      label: "Delete",
      className: "btn btn-link",
      icon: <DeleteIcon />,
      title: "delete",
      clickHandler: ActionHandler,
    },
  ];

  // console.log("shiftData>>>>>", pageStates?.shiftData);

  return (
    <>
      <>
        <div className="content">
          <MainHeading
            title={"Shift & Time Configuration"}
            buttonText={"Add Shift & Time Config"}
            buttonIcon={<PlusIcon />}
            buttonLink={RoutesLink?.add_Shift}
          />
          <div className="card mb-4">
            <div className="card-body">
              <FilterComponent />
              <CommonTable
                TableHeading={TableHeading}
                TableData={pageStates?.shiftData}
                ActionData={ActionData}
                currentPage={pageStates?.currentPage}
                PageChangeHandler={PageChangeHandler}
                isLoading={pageStates?.tableLoader}
                totalPages={pageStates?.totalPages}
                count={pageStates?.count}
                handleChangePageSize={handleChangePageSize}
                pageSize={pageStates.pageSize}
              />
            </div>
          </div>
        </div>
      </>
      <ConfirmModal
        modal={modal}
        toggle={toggle}
        submitHandler={HandleDelete}
        isLoading={isLoading}
      />
    </>
  );
}
